import { render, staticRenderFns } from "./CreatePostVideoButton.vue?vue&type=template&id=3be0956e&"
import script from "./CreatePostVideoButton.vue?vue&type=script&lang=js&"
export * from "./CreatePostVideoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports